import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { CardModule } from 'primeng/card';
import { FormsModule } from '@angular/forms';
import { LinkdindetailsFetchComponent, ExtractedLinkedInData } from '../sections/linkdindetails-fetch/linkdindetails-fetch.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-onboarding-landing',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    FileUploadModule,
    CardModule,
    LinkdindetailsFetchComponent,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './onboarding-landing.component.html',
  styleUrls: ['./onboarding-landing.component.scss']
})
export class OnboardingLandingComponent {

  @ViewChild(LinkdindetailsFetchComponent) linkedinModal!: LinkdindetailsFetchComponent;

  @Output() modeSelected = new EventEmitter<'parse' | 'manual'>();
  @Output() filesUploaded = new EventEmitter<File[]>();

  linkedinUrl = '';
  isModalVisible = false;

  constructor(private messageService: MessageService) {}

  fetchFromLinkedIn(): void {
    if (!this.linkedinUrl?.trim()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'LinkedIn URL required',
        detail: 'e.g. linkedin.com/in/your-username'
      });
      return;
    }

    if (!this.isValidLinkedInUrl(this.linkedinUrl)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid LinkedIn URL',
        detail: 'Please enter a valid LinkedIn profile URL'
      });
      return;
    }

    // Show modal — set isModalVisible FIRST so *ngIf renders the component,
    // then call show() after Angular has created it via setTimeout
    this.isModalVisible = true;

    setTimeout(() => {
      const fileName = this.extractNameFromUrl(this.linkedinUrl);
      this.linkedinModal?.show(fileName);
    }, 0);
  }

  selectManual(): void {
    this.modeSelected.emit('manual');
  }

  onLinkedInDataExtracted(data: ExtractedLinkedInData): void {
    this.isModalVisible = false;

    this.messageService.add({
      severity: 'success',
      summary: 'Data Extracted',
      detail: `Successfully extracted data${data.fullName ? ' for ' + data.fullName : ''}`
    });

    this.modeSelected.emit('parse');
    this.linkedinUrl = '';
  }

  onModalClose(): void {
    this.isModalVisible = false;
  }

  onDocumentUpload(event: any): void {
    const files = event.files as File[];
    this.filesUploaded.emit(files);
    this.modeSelected.emit('parse');
  }

  private isValidLinkedInUrl(url: string): boolean {
    const pattern = /linkedin\.com\/in\/[\w-]+/i;
    return pattern.test(url);
  }

  private extractNameFromUrl(url: string): string {
    const match = url.match(/linkedin\.com\/in\/([\w-]+)/i);
    return match?.[1] ? `${match[1]}'s Profile` : 'LinkedIn Profile';
  }
}